import { Component,OnInit } from '@angular/core';
import { APPCONFIG } from '../config';
import { FormGroup, FormBuilder, FormControl,FormArray, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service'
import { MdDialog,MdDialogRef } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import * as $ from 'jquery';

@Component({
    template: require('./inspection.component.html')
})

export class InspectionComponent {

    inspectionForm: FormGroup;
    formData:any = {};
    dialogRef;
    userData:any;
    isSuccess:boolean = false;
    isFS:boolean = false;
    socID:any;
    returnId:any;
    socList:any=[];
    constructor(private router: Router,private commonService : CommonService,private route: ActivatedRoute,private sessionHandler:SessionHandler,
    private http:HttpService,private dialog: MdDialog,private formBuilder: FormBuilder,) {

        if(this.http.checkSession()){
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            if(this.userData && this.userData.role && this.userData.role.length > 0){
                if(this.userData.role.includes('EMPLOYEE') || this.userData.role.includes('ADMIN')) {
                    this.isFS = true;
                } else {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'You are not authorized to access this page.';
                    this.dialogRef.afterClosed().subscribe(result => {
                        if(result){
                            this.router.navigateByUrl('/app/dashboard');
                            this.dialogRef = null;
                        }
                    });
                }
                // for(let u in this.userData.role){
                //     if(this.userData.role[u] == 'EMPLOYEE' || this.userData.role[u] == 'ADMIN') {
                //         this.isFS = true;
                //     } else {
                //         this.dialogRef = this.dialog.open(dialogComponent);
                //         this.dialogRef.componentInstance.msg = 'You are not authorized to access this page.';
                //         this.dialogRef.afterClosed().subscribe(result => {
                //             if(result){
                //                 this.router.navigateByUrl('/app/dashboard');
                //                 this.dialogRef = null;
                //             }
                //         });
                //     }
                // }
            }
        } else {
            this.http.showSessionError();
        }
    }
    ngOnInit() {
        this.buildForm();
    }

    public buildForm() {
        this.inspectionForm = this.formBuilder.group({
            tradePartnerId: this.formBuilder.control({value:null,disabled: true}, [Validators.required]),
            returnOrderId: this.formBuilder.control(null, [Validators.required]),
            customerMaterialNumber: this.formBuilder.control(null, [Validators.required]),
            serialNumber: this.formBuilder.control(null, [])
        });
        this.inspectionForm.get('customerMaterialNumber').valueChanges.subscribe(data=> {
            if(data) {
                this.isSuccess = false;
            }
        });
    }

    public resetTradeId(){
        this.inspectionForm.controls['tradePartnerId'].setValue(null);
    }
    public reset(){
        this.inspectionForm.controls['tradePartnerId'].setValue(null);
        this.inspectionForm.controls['returnOrderId'].setValue(null);
        this.inspectionForm.controls['customerMaterialNumber'].setValue(null);
        this.inspectionForm.controls['serialNumber'].setValue(null);
        this.isSuccess = false;
        $('html, body').animate({
            scrollTop: $("#inspectionForm").offset().top
        }, 1000);
    }

    public getTradeId(){
        this.formData = this.inspectionForm.getRawValue();
        this.http.getRequest('returnOrder/v1/getTradePartnerByOrderId?sapOrderId='+ this.formData.returnOrderId)
        .subscribe(
            res => {
                this.saveTradeResponse(res)
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;
                    }
                    this.http.onEnd();
        });
    }

    public getSocList() {
        this.http.getRequest('returnOrder/v1/getSocRequestsByReturnId?returnOrderId='+ this.formData.returnOrderId)
        .subscribe(
            res => {
                this.saveSocList(res);
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
        });
    }

    public saveTradeResponse(res){
        if(res.status == "Success" && res.items && res.items.length > 0){
            this.inspectionForm.controls['tradePartnerId'].setValue(res.items[0]);
            // this.getSocList();
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }

    public saveSocList(res) {
        console.log(res);
        if(res.status == 'Success' && res.createdSocList.length >0) {
            this.socList = res.createdSocList;
        }
    }
    public createSOC(){
        let check = false;
        this.formData = this.inspectionForm.getRawValue();
        this.formData.userId = 8;//this.userData.userId;
        if(this.formData.serialNumber && this.formData.serialNumber != '') {
            this.formData.serialNumber = this.formData.serialNumber.toUpperCase();
            if(this.formData.serialNumber.length == 9){
                if(/^[Ww][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(this.formData.serialNumber) == false){
                    check = false;
                } else {
                    check = true;
                }
            }else if(this.formData.serialNumber.length == 10){
                if(/^[WwYyDd][A-Za-z][A-Za-z0-9]([0-4][0-9]|5[0-3])\d{5}$/.test(this.formData.serialNumber) == false){
                    check = false;
                } else {
                    check = true;
                }
            }
        } else {
            check = true;
        }
        if(check){
            this.http.postRequest(this.formData,'returnOrder/v1/saveSocReturnOrder').subscribe(
                res => {
                    this.saveResponse(res);
                    },
                    err => {
                        if(err && err.status!=0){

                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;
                        }
                        this.http.onEnd();
                    }
                );
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Please enter valid serial number of length 9 or 10.';
        }
    }

    public saveResponse(res){
        if(res.status == "Success"){
            this.dialogRef = this.dialog.open(dialogComponent,{disableClose:true});
            this.dialogRef.componentInstance.msg = 'SOC ID - '+res.socID+' created successfully.';
            this.dialogRef.afterClosed().subscribe(result => {
                this.socID = res.socID;
                this.inspectionForm.controls['customerMaterialNumber'].setValue(null);
                this.inspectionForm.controls['serialNumber'].setValue(null);
                this.isSuccess = true;
            });
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/inspection/inspection.component.ts